import { z } from 'zod';

/** Utilisateur authentifié du back-office (TD-027). */
export const currentUserSchema = z.object({
  email: z.string(),
  isAdmin: z.boolean(),
});

export type CurrentUser = z.infer<typeof currentUserSchema>;
